<template>
   <Html class="bg-light-grey">
      <ClientOnly>
         <NuxtLoadingIndicator :height="5" color="var(--color-secondary)" />
         <Notification />
      </ClientOnly>

      <Body>
         <PreviewDisclaimer />

         <div
            id="app-layout"
            class="bg-light-grey flex min-h-screen flex-col items-center justify-center gap-10 p-3 max-md:p-2"
         >
            <main class="rounded-small min-h-screen w-full max-w-[1400px] overflow-hidden bg-white">
               <slot />
            </main>
         </div>
      </Body>
   </Html>
</template>

<script lang="ts" setup>
const { t } = useI18n()

useSeo(t('web.seo.layout.legal.title'), t('web.seo.layout.legal.description'))
</script>
